<template>
  <div class="layout">
    <Layout>
      <Header>
        <Navbar/>
      </Header>
      <Layout :style="{padding: '0 50px'}">
        <Breadcrumb :style="{margin: '16px 0'}">
          <BreadcrumbItem>Home</BreadcrumbItem>
          <BreadcrumbItem>Category</BreadcrumbItem>
          <BreadcrumbItem>{{this.$route.params.category}}</BreadcrumbItem>
        </Breadcrumb>
        <Content :style="{padding: '24px 0', minHeight: '280px', background: '#fff'}">
          <Layout>
            <Sider hide-trigger :style="{background: '#fff'}">
              <Menu active-name="1-2" theme="light" width="auto" :open-names="['1']">
                <Submenu name="1">
                  <template slot="title">
                    <Icon type="ios-navigate"></Icon>Price
                  </template>
                  <MenuItem name="1-1">
                    <InputNumber :max="10" :min="1"></InputNumber>-
                    <InputNumber :max="10" :min="500"></InputNumber>
                  </MenuItem>
                </Submenu>
                <Submenu name="2">
                  <template slot="title">
                    <Icon type="ios-keypad"></Icon>Brands
                  </template>
                  <div v-for="item in category" :key="item.name">
                    <MenuItem v-show="item.type === title" :name="item.name">{{item.name}}</MenuItem>
                  </div>
                </Submenu>
                <Submenu name="3">
                  <template slot="title">
                    <Icon type="ios-analytics"></Icon>OS
                  </template>
                  <div v-for="item in opsystem" :key="item.name">
                    <MenuItem :name="item.name">{{item.name}}</MenuItem>
                  </div>
                </Submenu>
              </Menu>
            </Sider>
            <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
              <h4> {{this.$route.params.category}}</h4>
              <Trending tag="laptop"/>
            </Content>
          </Layout>
        </Content>
      </Layout>
      <Footer class="layout-footer-center">
        2020 &copy; Hi2Peer
      </Footer>
    </Layout>
  </div>
</template>
<script>
import Trending from "@/components/Trending.vue"
import Navbar from "@/components/Navbar.vue"
export default {
  name: "Home",
  components: {
    Trending,
    Navbar
  },
  data() {
    return {
      title: '',
      category: [
        { 
          type: 'laptop',
          name:'Dell'}, 
        { 
          type: 'laptop',
          name:'Mac'}, 
        { 
          type: 'laptop',
          name:'Razer'}, 
        { 
          type: 'laptop',
          name:'Asus'}, 
        { 
          type: 'laptop',
          name:'HP'},
        { 
          type: 'smartphone',
          name:'Samsung'}, 
        { 
          type: 'smartphone',
          name:'Apple'}, 
        { 
          type: 'smartphone',
          name:'Huawei'}, 
        { 
          type: 'smartphone',
          name:'Sony'}, 
        { 
          type: 'smartphone',
          name:'HTC'},
        { 
          type: 'smartphone',
          name:'Motorola'}, 
        { 
          type: 'smartphone',
          name:'Lenovo'}
      ],
      opsystem: [
        {name: 'Android'},
        {name: 'iOS'},
        {name: 'Window'},
        {name: 'Other'},
      ]
    }
  },
  created() {
      this.title = this.$route.params.category
  }
}
</script>
<style>
.ivu-input-number {
  width: 60px;
}
</style>
